import { SwOrder } from '../response-types/support'
import * as t from '../types'
import * as utils from '../utils'

export default function transformOrder(swOrder: SwOrder): t.Order {
  let deliveryReduction = 0
  for (const item of swOrder.lineItems) {
    if (item.type !== 'promotion') continue
    if (item.payload.discountScope !== 'delivery') continue
    deliveryReduction += parseFloat(item.payload.value)
  }

  const transactions = swOrder.transactions.sort((a, b) =>
    new Date(a.createdAt).getTime() > new Date(b.createdAt).getTime() ? -1 : 1
  )

  //check if payment is creditcard or paypal and status is not paid
  const paymentNecessary = !swOrder.tags.find(
    (tag) =>
      tag._uniqueIdentifier === '07377c57348b44ca877e591694e649bf' ||
      tag.id === '07377c57348b44ca877e591694e649bf'
  )

  return {
    id: swOrder.id,
    specialDelivery: !!swOrder.deliveries.find(
      (row) => row.shippingMethodId === '10f0e51f044845d0b90ab6b9ffea9c52'
    ),
    status: transactions[0].stateMachineState.technicalName,
    createdAt: swOrder.createdAt,
    currencyId: swOrder.currencyId,
    languageId: swOrder.languageId,
    orderNumber: swOrder.orderNumber,
    salesChannelId: swOrder.salesChannelId,
    shippingMethodId: swOrder.deliveries[0]?.shippingMethodId || '',
    paymentMethodId: transactions[0]?.paymentMethodId || '',
    billingAddress: utils.createAddress(swOrder.billingAddress),
    shippingAddress: utils.createAddress(
      swOrder.deliveries[0]?.shippingOrderAddress
    ),
    paymentChangeable: false,
    paymentNecessary: paymentNecessary,
    deliveryCost: swOrder.shippingTotal + deliveryReduction,
    deliveryReduction: deliveryReduction,

    positionPrice: swOrder.positionPrice,
    promotionItems: swOrder.lineItems
      .filter((item) => item.type === 'promotion')
      .map((item) => ({
        reduction: item.totalPrice,
        code: item.referencedId,
        cartItemId: item.id,
        priceDefinitionType: item.priceDefinition?.type || '',
        priceDefinitionPercentage: item.priceDefinition?.percentage || 0,
        priceDefinitionAbsolute: item.priceDefinition?.price || 0
      })),
    tax: swOrder.price.calculatedTaxes[0]?.tax || 0,
    taxRate: swOrder.price.calculatedTaxes[0]?.taxRate || 0,
    totalPrice: swOrder.amountTotal,
    lineItems: swOrder.lineItems
      .filter((item) => item.type === 'product')
      .map((item) => ({
        sw6Uuid: item.productId,
        quantity: item.quantity,
        unitPrice: item.unitPrice,
        totalPrice: item.totalPrice,
        additionalInformation: item.payload.additionalInformation,
        customTailor: item.payload.customProductData
      }))
  }
}
